import { render, staticRenderFns } from "./admin_units_list_buttons_view.vue?vue&type=template&id=784996bf&"
import script from "./admin_units_list_buttons_view.vue?vue&type=script&lang=js&"
export * from "./admin_units_list_buttons_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports